// Детерминированный выбор (spec §6, формализация G7-2 s167).
//
// Вход — qualified[]: per этап объект { F: quote } только с qualifying-полями
// (прошли рубрику §3 И verbatim §5). Выход — per этап { field, quote } | null.

import { FIELDS, REGISTER } from './thresholds.js';

/**
 * Доминирующее поле (нить, §6.1): тип с макс. числом qualifying-этапов.
 * Тай между типами → register-fit порядок T3>T2>T1.
 * @returns {string|null} F или null, если qualifying нет ни на одном этапе
 */
export function dominantField(qualified) {
  const counts = Object.fromEntries(FIELDS.map((F) => [F, 0]));
  for (const stageQual of qualified) {
    for (const F of FIELDS) {
      if (stageQual && stageQual[F] != null) counts[F] += 1;
    }
  }
  const max = Math.max(...Object.values(counts));
  if (max === 0) return null;
  // тай → первый по register-fit
  return REGISTER.find((F) => counts[F] === max) ?? null;
}

/**
 * Выбор цитаты на одном этапе (§6.2):
 *   1. dominant qualifying здесь → берём (нить);
 *   2. иначе спуск по register-fit T3→T2→T1, первое qualifying;
 *   3. финальный тайбрейк shortest-qualifying — register-порядок тотален над
 *      различными T-id, поэтому на практике не срабатывает (документировано §6.2).
 * @returns {{field:string, quote:string}|null}
 */
export function selectForStage(stageQual, dominant) {
  if (!stageQual) return null;
  if (dominant && stageQual[dominant] != null) {
    return { field: dominant, quote: stageQual[dominant] };
  }
  for (const F of REGISTER) {
    if (stageQual[F] != null) return { field: F, quote: stageQual[F] };
  }
  return null;
}

/**
 * Полный выбор по арке: dominance → per-stage select.
 * @returns {Array<{field, quote}|null>} по этапу
 */
export function selectAcrossArc(qualified) {
  const dom = dominantField(qualified);
  return qualified.map((sq) => selectForStage(sq, dom));
}
